import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { initializeApp, provideFirebaseApp } from '@angular/fire/app';
import { Auth, getAuth, provideAuth } from '@angular/fire/auth';

import { environment } from '../../../environments/environment';

export const FIREBASE_NOT_CONFIGURED =
  'Firebase is not configured. Set firebaseConfig.apiKey and authDomain in ' +
  'src/environments/environment.ts before using sign-in.';

export function isFirebaseConfigured(): boolean {
  return Boolean(environment.firebaseConfig.apiKey);
}

export function provideFirebaseAuth(): EnvironmentProviders {
  if (isFirebaseConfigured()) {
    return makeEnvironmentProviders([
      provideFirebaseApp(() => initializeApp(environment.firebaseConfig)),
      provideAuth(() => getAuth()),
    ]);
  }

  if (!environment.production) {
    console.warn(FIREBASE_NOT_CONFIGURED);
  }

  return makeEnvironmentProviders([{ provide: Auth, useValue: createInertAuth() }]);
}

function createInertAuth(): Auth {
  return { name: '[unconfigured]', currentUser: null, config: {} } as unknown as Auth;
}
